import { Dm, Media, DmConversation } from "@adalong/schemas";
import { z } from 'zod';
import { RightRequest } from "../apiTypes";
import { CRMTemplateSource, CRMTemplateType } from "../models/CRMTemplate";
import { UserView } from "./user";

export type ConversationView = EnrichedConversationMetadata[]

export interface DmsView {
  Dms: Dm[]
  cursor?: string
}

export interface StoredConversationView {
  conversations: StoredConversation[];
  cursor?: string;
}

export interface StoredConversation {
  conversationId: string
  interlocutorUsername: string
  rightRequests: EnrichedRightRequest[]
  interlocutorId: string
  targetAccountId: string
  lastActivityDate?: string | null
  isFavorite?: boolean
  isUnread?: boolean
}

export interface EnrichedRightRequest {
  rightRequest: RightRequest
  medias?: Media[]
}

export type RemoteConversationView = {
  conversations: DmConversation[];
  cursor?: string;
}

export interface EnrichedConversationMetadata {
  conversation: ConversationMetadata;
  rightRequests?: EnrichedRightRequestMetadata[];
}

export interface EnrichedRightRequestMetadata {
  rightRequest: Pick<RightRequest, 'codeOfPost' | 'status' | 'source'>;
  medias?: Pick<Media, 'url' | 'lang' | 'diffusion'>[];
}

export interface ConversationMetadata {
  interlocutor: {
    name: string;
    id: string;
    pictureUrl: string;
  };
  targetAccount: {
    id: string;
    name: string;
  };
  lastActivityDate: string;
  networkName: string;
  conversationId: string;
  lastMessage: string;
  isFavorite: boolean;
  isUnread?: boolean;
}

export interface ConversationMessage {
  message: string;
  networkMessageId: string;
  networkName: string;
  networkReceiverId: string;
  networkSenderId: string;
  readDate?: number;
  receivedDate: string;
}

export const BodyCreateMessageSchema = z.object({
  interlocutorId: z.string(),
  // which account connected to adalong will send the message
  senderAccountId: z.string(),
  networkName: z.string(),
  // body of the message
  body: z.string(),
});

export type BodyCreateMessage = z.infer<typeof BodyCreateMessageSchema>;

export const BodyCreateMessagesSchema = z.object({
  peers: z.array(z.object({
    interlocutorId: z.string(),
    // which account connected to adalong will send the message
    senderAccountId: z.string(),
  })),
  networkName: z.string(),
  // body of the messages
  body: z.string(),
});

export type BodyCreateMessages = z.infer<typeof BodyCreateMessagesSchema>;

export interface CRMTemplateView {
  _id: string;
  owner: Partial<UserView> & Pick<UserView, '_id'>
  source: CRMTemplateSource;
  market?: string;
  language?: string;
  type: CRMTemplateType;
  name: string;
  url?: string;
  content: string;
  terms?: string;
  hashtag?: string;
  createdAt: string;
  default: boolean;
}
